import ConfirmDeleteOverloadModal from './ConfirmDeleteOverloadModal';
export default ConfirmDeleteOverloadModal;
